module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Billing"},"es":{"title":"Facturación"},"fr":{"title":"Facturation"},"it":{"title":"Fatturazione"},"pt":{"title":"Faturação"},"pl":{"title":"Rozliczenia"}}')
  delete Component.options._Ctor
}
